export default function validationSansSuite(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    const i18nType = 'validationCommande';
    if (message.indexOf('LINE_AFTER_CLOSING') === 0) {
      messages.push({ message: 'validationCommande.closingLineAfterDate' });
    }
    if (message.indexOf('DATE_REQUIRED') === 0) {
      messages.push({ message: 'validationCommande.closingDateMandatory' });
    }
    if (message.indexOf('SCHEDULE_AFTER_CLOSING') === 0) {
      messages.push({ message: 'validationCommande.closingScheduleAfterDate' });
    }
    if (message.indexOf('WRONG_STATE_FOR_CLOSING') === 0) {
      messages.push({ message: 'validationCommande.closingWrongState' });
    }
    if (message.indexOf('INSUFFICIENT_STOCK_DATED') === 0) {
      const errorStock = message.split('|')[0].split('@');
      messages.push({
        message: i18nType + '.insuficientStockDated',
        parametres: {
          produit: errorStock[2],
          dateDebut: errorStock[3].split(' ')[0],
          dateFin: errorStock[4].split(' ')[0],
        },
      });
    }
  });
}
